import { combineReducers } from "redux";

import contrattoReducer from "./Contratto";
import loginReducer from "./Login";

export default combineReducers({
  contrattoReducer,
  loginReducer,
});
